import styled from 'styled-components';
import { remCalc } from '@prisjakt/ui-base';

export const PriceFilter = styled.div.attrs({ 'data-test': 'PriceFilter' })`
  margin-top: ${remCalc(10)};
  margin-bottom: ${remCalc(10)};
`;
